import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { htmlEncode } from '../../../utils/escape.utils';

export class TimelineItemView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$alertTitle = this.shadow.querySelector('#alertTitle');
    this.dom.$killChainStep = this.shadow.querySelector('#killChainStep');
    this.dom.$severity = this.shadow.querySelector('#severity');
    this.dom.$severityLabel = this.shadow.querySelector('#severity-label');
    this.dom.$severityClass = this.shadow.querySelector('.timeline-item-container');
    this.dom.$alertDescription = this.shadow.querySelector('#alertDescription');
    this.dom.$classIcon = this.shadow.querySelector('#icon-title');
    this.dom.$sensor = this.shadow.querySelector('#sensor');
    this.dom.alertTitleTooltip = this.shadow.querySelector('.alertTitle-tooltip');
    this.dom.$killChainTooltip = this.shadow.querySelector('.killChainStep-tooltip');
    this.dom.$identicalTactic = this.shadow.querySelector('#identicalTactic');
    this.dom.$gzLinkComponent = this.shadow.querySelector('gz-link');
    this.dom.$numberOfEndpoints = this.shadow.querySelector('#numberOfEndpoints');
    this.dom.$numberOfServers = this.shadow.querySelector('#numberOfServers');
    this.dom.$numberOfInternalEmails = this.shadow.querySelector('#numberOfInternalEmails');
    this.dom.$numberOfIps = this.shadow.querySelector('#numberOfIps');
    this.dom.$numberOfIdentities = this.shadow.querySelector('#numberOfIdentities');
  }

  buildView(data: any) {
    if (!data || !data.response) {
      this.dom.$wrapper.innerHTML = '';
      return;
    }
    this.dom.$classIcon ? this.dom.$classIcon.classList.add(data.response.classIcon) : '';
    this.shadow.host.style.setProperty('--severity-color', data.response.severityColor);

    const alertTitle = htmlEncode(data.response.alertTitle);
    this.dom.$alertTitle.innerHTML = alertTitle;
    this.dom.alertTitleTooltip.tooltipText = alertTitle;

    const killChain = htmlEncode(this.dependencies.translateKillChainPhases(data.response.killChainPhases));
    this.dom.$killChainStep.innerHTML = killChain;
    this.dom.$killChainTooltip.tooltipText = killChain;

    this.dom.$severity.innerHTML = htmlEncode(this.dependencies.translateEdrEventSeverity(data.response.severity));
    this.dom.$severityLabel.innerHTML = this.dependencies.translateFn('Severity') + ": ";
    this.dom.$alertDescription.innerHTML = data.response.alertDescription;
    this.dom.$sensor.innerHTML = data.response.sensor;

    const { numberOfEndpoints, numberOfServers, numberOfInternalEmails, numberOfIps, numberOfIdentities } =
      data.response;

    this.dom.$numberOfEndpoints.querySelector('span').innerHTML = numberOfEndpoints;
    this.dom.$numberOfServers.querySelector('span').innerHTML = numberOfServers;
    this.dom.$numberOfInternalEmails.querySelector('span').innerHTML = numberOfInternalEmails;
    this.dom.$numberOfIps.querySelector('span').innerHTML = numberOfIps;
    this.dom.$numberOfIdentities.querySelector('span').innerHTML = numberOfIdentities;

    this.dom.$identicalTactic.innerHTML = htmlEncode(
      this.dependencies.translateFn('+ {numberOfAlerts} other {killChain} alerts', {
        numberOfAlerts: data.response.identicalTactic,
        killChain: killChain,
      })
    );

    if (!data.response.identicalTactic) {
      this.dom.$identicalTactic.style.display = 'none';
    }

    Object.entries({
      numberOfEndpoints,
      numberOfServers,
      numberOfInternalEmails,
      numberOfIps,
      numberOfIdentities,
    }).forEach(([key, value]) => {
      const currentDomElement = this.dom['$' + key];
      if (!value || value < 0) {
        currentDomElement.style.display = 'none';
      }
    });

    this.dom.$gzLinkComponent.showIcon = false;
  }
}
